import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Text } from 'rizzui';
import CustomCalendar from '../../../components/calendar/Calendar';
import { Loader } from '../../../components/loader/SpinnerLogo';
import useFetch from '../../../hooks/useFetch';
import Page from '../../../layout/Page/Page';
import { menuRoutes } from '../../../router/menu';
import { FacilitatorCallsService } from '../../../services/calls/facilitatorCallsService';

const FacilitatorScheduledCalls = () => {
    const navigate = useNavigate();
    const service = new FacilitatorCallsService();

    const [response, loading, error] = useFetch(useCallback(async () => {
        const apiResponse = await service.listScheduled({
            page: 1,
            limit: 500,
            filter_order: [{ field: 'scheduledAt', order: 'asc' }],
        });

        return apiResponse.getResponseData();
    }, []));

    const rows = response?.data ?? [];
    const events = rows
        .filter((row: any) => row.scheduledAt?.date || row.scheduledAt)
        .map((row: any) => {
            const startValue = row.scheduledAt?.date || row.scheduledAt;
            const start = new Date(startValue);
            const end = new Date(start.getTime() + 30 * 60 * 1000);

            return {
                id: row.id,
                title: `${row.contract?.studentName || row.contract?.studentFirstName || row.contract?.code || 'Contrato'} · ${row.classification?.name || 'Seguimiento'}`,
                start,
                end,
                contractId: row.contract?.id,
            };
        });

    if (loading && !response) {
        return <Loader height="50vh" />;
    }

    if (!loading && error) {
        return (
            <Page container="fluid">
                <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
                    No se ha podido cargar el listado de llamadas agendadas.
                </div>
            </Page>
        );
    }

    return (
        <Page container="fluid">
            <div className="space-y-4">
                <div className="rounded-md border border-gray-200 bg-white p-4">
                    <Text className="text-sm text-gray-600">
                        {events.length === 0 ? 'No hay seguimientos agendados en este momento.' : `Total de eventos agendados: ${events.length}`}
                    </Text>
                </div>
                <div className="rounded-md border border-gray-200 bg-white p-4">
                    <CustomCalendar
                        defaultView="agenda"
                        events={events}
                        handleSelectEvent={(event) => {
                            if (!event.contractId) {
                                return;
                            }

                            navigate(`${menuRoutes.contracts.path}/${event.contractId}/profile${menuRoutes.contracts.profile.tracking}`);
                        }}
                        className="h-[760px]"
                    />
                </div>
            </div>
        </Page>
    );
};

export default FacilitatorScheduledCalls;
